import Select, { SelectProps } from "@/shared/form/select";
import { RouteRoleOptionFragment } from "gql/graphql";
import { useRouteRoleOptions } from "@/shared/form/process-route-step-input/model/use-route-role-options";

export function RouteRoleSelect({
  roles,
  ...props
}: SelectProps & { roles: RouteRoleOptionFragment[] }) {
  const { options } = useRouteRoleOptions(roles);

  return (
    <Select
      options={options}
      showSearch
      optionFilterProp="label"
      allowClear
      {...props}
    />
  );
}
